import React from 'react';
import PropTypes from 'prop-types';
import { Card, List, Tag } from 'antd';
import { formatDate } from '../../../services/util/date';

const TAG_COLORS = {
  PAID: 'green',
  PENDING: 'warning',
};

function PayrollItemList({ items }) {
  return (
    <Card
      style={{ borderRadius: 12 }}
      bodyStyle={{ padding: 0 }}
    >
      <List
        itemLayout="horizontal"
        dataSource={items}
        renderItem={(item) => {
          const cooperator = item.cooperator || {};
          const isPaid = !!item.paidDate;

          return (
            <List.Item
              style={{
                padding: '16px 20px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <List.Item.Meta
                title={<span style={{ fontWeight: 500 }}>{cooperator.name}</span>}
                description={<span>{cooperator.cpf}</span>}
              />

              <div style={{ textAlign: 'right' }}>
                <Tag
                  color={isPaid ? TAG_COLORS.PAID : TAG_COLORS.PENDING}
                  style={{
                    borderRadius: 8,
                    border: 'none',
                    marginTop: 4,
                    marginRight: 0,
                  }}
                >
                  {isPaid ? `Pago em ${formatDate(item.paidDate)}` : 'Pendente'}
                </Tag>
              </div>
            </List.Item>
          );
        }}
      />
    </Card>
  );
}

PayrollItemList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default PayrollItemList;
